module.exports = __webpack_public_path__ + "img/tutorial.42448038.png";